import { STATES } from '../../../../constants';

export function ShareMoveCustomizeConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_SHARE_MOVE_CUSTOMIZE, {
    url: '',
    views: {
      '@': {
        template: '<upd-share-move-customize></upd-share-move-customize>',
      },
    },
    scrollTop: true,
    titleBar: {
      title: 'Send Moving Announcements',
      icon: 'share',
      save: 'Time Saved: 32 minutes',
    },
    analytics: {
      page: 'Customize Moving Announcement',
    },
    data: {
      permissions: 'signedIn',
    },
  });
}
